
import { getUserConversations, getConversation } from './conversation-fire.js'

import { sendChatNotification } from './chat-notifications'

const conversationsMiddelware = store => next => action => {

  switch (action.type) {
    case "sendChatNotification": {

      var {conversationData} = action
      next(action);
      var {user} = store.getState()

      return sendChatNotification(conversationData, user, next)

        .then((chatNotificationResponse => {

          return getConversation(conversationData.id, next)

        }))

        .then((initConversationResponseAction => {

          return window.location.hash = "messaging"

        }))

    }
    case "getUserConversations": {
      next(action);
      var {user} = store.getState()

      return getUserConversations(action.userId, next)

    }
    default:
      return next(action)
  }

}

export default conversationsMiddelware;


// WEBPACK FOOTER //
// ./src/Components/Conversations/middleware/index.js